import { isNumber } from "lodash"
import { ANCHOR_BLANK } from "../../shared_component/constants/common"
import { GOOGLE_MAP_BASE_URL } from "../constants/mapbox"

/**
 * Opens a location in Google Maps in a new browser tab.
 *
 * @param {number} latitude - The latitude of the location.
 * @param {number} longitude - The longitude of the location.
 * @param {string} [label=""] - Optional label to display on the map.
 *
 * @example
 * // Opens Google Maps for the specified latitude and longitude
 * openInGoogleMaps(37.7749, -122.4194, "San Francisco");
 */
export const openInGoogleMaps = (latitude, longitude, label = "") => {
  if (!isNumber(latitude) || !isNumber(longitude)) {
    return
  }

  const baseUrl = GOOGLE_MAP_BASE_URL
  const locationUrl = `${baseUrl}${latitude},${longitude}${
    label ? ` (${encodeURIComponent(label)})` : ""
  }`

  window.open(locationUrl, ANCHOR_BLANK)
}

export default openInGoogleMaps
